module.exports = __webpack_public_path__ + "img/chart-simple-solid.bbec251b.svg";